module.exports = __webpack_public_path__ + "img/signup-email2.349e71f1.png";